 
const firebaseConfig = {
  apiKey: "AIzaSyDTWNiX1L1jBhDlFGQuw9BHIMfEV5lAGzI",
  authDomain: "take-a-trip-web-app.firebaseapp.com",
  projectId: "take-a-trip-web-app",
  storageBucket: "take-a-trip-web-app.appspot.com",
  messagingSenderId: "750213727507",
  appId: "1:750213727507:web:7f17e1bbb4ef2c49ca46e6"
};
export default firebaseConfig;